<fc-modal [id]="modalId" [options]="options">
    <div *ngIf="openAccessRequest" class="fc-confirm-dialog">
        <div class="fc-dialog-text-section">
            <h3>{{ 'RIGHTS_MANAGEMENT.RETAILER_NOTE' | translate }}</h3>
            <p>
                {{ openAccessRequest.retailerOrganization.name }} - {{ openAccessRequest.accessRequests[0].brandName }}
            </p>
            <div class="fc-access-note">
                <p class="fc-access-note-text">"{{ openAccessRequest.accessRequests[0].note }}"</p>
            </div>
        </div>
        <div class="fc-dialog-button-section">
            <div class="fc-access-note-button">
                <button fcp-button (click)="close()">
                    {{ 'DONE' | translate }}
                </button>
            </div>
        </div>
    </div>
</fc-modal>
